/**
 * In-tab mutex for GoTrue. supabase-js defaults to navigator.locks, which is
 * origin-wide (every Maater tab). When two tabs initialize or one tab's
 * updateUser/getSession races another tab's createClient(), the Web Lock
 * request times out as AbortError and the constructor's initialize() rejects
 * uncaught (incident: 2026-09-01-supabase-navigator-locks-abort-cascade).
 * Serializing only inside this JS realm avoids that; two tabs may refresh
 * the access token concurrently, which is acceptable vs a false sign-out.
 */
let authLockTail: Promise<void> = Promise.resolve()

export async function inProcessAuthLock<R>(
  _name: string,
  _acquireTimeout: number,
  fn: () => Promise<R>,
): Promise<R> {
  let release!: () => void
  const previous = authLockTail
  authLockTail = new Promise<void>((resolve) => {
    release = resolve
  })
  try {
    await previous
    return await fn()
  } finally {
    release()
  }
}
